import { FeatureFragment } from "@graphqlTypes";
import { usePageWrapperData } from "@/providers/PageWrapperContext";

export type POST_TYPES = FeatureFragment['items'][number]['page']['node']['__typename'];

const STATIC_TYPE: { [key in POST_TYPES]: string; } = {
  Event: "event",
  Inductee: "inductee",
  Ceremony: "induction",
  Post: "post",
  Exhibit: "exhibit",
  DigitalExhibit: null,
  Option: null,
  GraphqlDocument: null,
  Page: null,
  MediaItem: null,
  TicketPrice: null,
  RhtvChannel: "rhtv",
  RhtvVideo: "rhtv",
  PressRelease: null,
  CoverStory: null,
  DeepDive: null,
  Quiz: null,
}

const EXHIBIT_SUB_TYPES: { [key: string]: string; } = {
  'interactive': 'interactive'
};

type Page = FeatureFragment['items'][number]['page']

type PageType = Page & {
  node?: Page['node'] & {
    __typename?: Page['node']['__typename']
  }
}

const getPostType = (page: PageType): string | null => {
  const pageData = page?.node;
  if (!pageData) return null;
  const { __typename: typeName } = pageData;
    
  // Convert to lowercase for case-insensitive matching
  const lowerTypeName = typeName.toLowerCase();
  const matchingKey = Object.keys(STATIC_TYPE).find(key => key.toLowerCase() === lowerTypeName);
  if (!matchingKey) return null;
    
  const actualTypeName = matchingKey as POST_TYPES;
  if (page.node.__typename === "Exhibit") {
    const subtype = page?.node?.exhibitTypes?.nodes[0]?.slug;
    const out = EXHIBIT_SUB_TYPES[subtype] || STATIC_TYPE[actualTypeName];
    return out;
  } else {
    return STATIC_TYPE[actualTypeName];
  }
};

export const usePostType = (page: PageType, debug = false): {
  label: string;
  key: string;
} | null => {
  const { labels } = usePageWrapperData();
  if (debug) console.log("usePostType", page?.node.__typename);
  const postTypeLabels = labels?.postTypeLabels;
  const postTypeKey = getPostType(page) as keyof typeof postTypeLabels;
  if (debug) { 
    console.log("usePostType", postTypeKey);
  }
  if (!postTypeKey) return null;
  const label = postTypeLabels?.[postTypeKey];
  if (!label) {
    console.warn(`Post type label not found for key: ${postTypeKey}`);
    return null;
  }
  const key = postTypeKey;

  return { label, key };
};